import React from 'react';
import styled from 'styled-components';

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xs};
`;

const LabelRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sm};
`;

const Label = styled.label`
  font-size: ${props => props.theme.typography.sizes.default};
  font-weight: ${props => props.theme.typography.weights.semiBold};
  color: ${props => props.theme.colors.text};
`;

const OptionalTag = styled.span`
  font-size: ${props => props.theme.typography.sizes.small};
  color: ${props => props.theme.colors.muted};
  font-weight: ${props => props.theme.typography.weights.normal};
`;

const Help = styled.div`
  font-size: ${props => props.theme.typography.sizes.small};
  color: ${props => props.theme.colors.muted};
  line-height: 1.4;
`;

const Slot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xs};
`;

export const PropertyField = ({
  label,
  help,
  htmlFor,
  optional = false,
  children,
}) => (
  <FieldWrapper>
    {label && (
      <LabelRow>
        <Label htmlFor={htmlFor}>{label}</Label>
        {optional && <OptionalTag>Optional</OptionalTag>}
      </LabelRow>
    )}
    <Slot>{children}</Slot>
    {help && <Help>{help}</Help>}
  </FieldWrapper>
);
